import { Colors, Text } from '@amelio/ui-library';

import { AdjustmentStatusPill } from './AdjustmentStatusPill';
import { TABLE_CELL } from '../calibrationStyles';

import type { CalibrationAdjustmentStatus } from '@/types/calibration';

export interface EmployeeIdentityCellProps {
    employeeId: string;
    name: string;
    /** Empty when the company carries no job title for this employee. */
    jobTitle: string;
    /** `null` when the employee has no calibration adjustment yet. */
    status: CalibrationAdjustmentStatus | null;
}

/** Who the row is about: name, the badge saying where their calibration stands, and the job title
 * underneath. No avatar — fifteen portraits down a data grid compete with the numbers. */
export const EmployeeIdentityCell = ({
    employeeId,
    name,
    jobTitle,
    status,
}: EmployeeIdentityCellProps) => (
    <td className={TABLE_CELL}>
        <div className={'flex flex-col gap-0.5'}>
            <div className={'flex flex-wrap items-center gap-2'}>
                <Text
                    weight={'semibold'}
                    color={Colors.NAVY}
                >
                    {name}
                </Text>

                <AdjustmentStatusPill
                    status={status}
                    dataTestId={`calibration-status-pill-${employeeId}`}
                />
            </div>

            {jobTitle.length > 0 && (
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {jobTitle}
                </Text>
            )}
        </div>
    </td>
);
